import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import { deixarMultipartPassar } from './multipart';

// Logger condicional: ativo apenas em DEV ou se window.__CMAX_DEBUG__ === true
const isDev = process.env.NODE_ENV === 'development';
const isDebug = () => isDev || (typeof window !== 'undefined' && window.__CMAX_DEBUG__ === true);

const log = (...args) => { if (isDebug()) console.log(...args); };
const warn = (...args) => { if (isDebug()) console.warn(...args); };
const errLog = (...args) => { if (isDebug()) console.error(...args); };

// Detecta o caminho base do app (suporta subpath /sistemas/centralmax/...)
const getLoginUrl = () => {
  if (typeof window === 'undefined') return '/login';
  const { pathname } = window.location;
  // Remove tudo a partir do segmento que termina com /build/ e adiciona /login
  const fbIdx = pathname.indexOf('/frontend/build');
  if (fbIdx >= 0) return pathname.substring(0, fbIdx + '/frontend/build'.length) + '/login';
  return '/login';
};

// `Content-Type` fixo em JSON, e o interceptor abaixo o remove quando o corpo
// é um arquivo. Tirá-lo daqui quebra POST sem corpo com 415: ver `multipart.js`.
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    deixarMultipartPassar(config);
    log(`[API REQUEST] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`, {
      params: config.params,
      data: config.data,
    });
    return config;
  },
  (error) => {
    errLog('[API REQUEST ERROR]', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    log(`[API RESPONSE] ${response.status} ${response.config.method?.toUpperCase()} ${response.config.url}`);
    return response;
  },
  (error) => {
    errLog(`[API ERROR] ${error.response?.status || 'NETWORK'} ${error.config?.method?.toUpperCase()} ${error.config?.url}`, error.response?.data || error.message);
    if (error.response?.status === 401) {
      warn('[AUTH] Token expirado ou inválido — redirecionando para login');
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = getLoginUrl();
    }
    return Promise.reject(error);
  }
);

export default api;
